
import { useSelector } from 'react-redux';

import { getSelectedGame } from '../redux/game/selectors'

const useCurrentGame = () => {
    return useSelector(state => getSelectedGame(state));
}

export default useCurrentGame;